<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="epi"> </p>
<p class="FMEP"><span epub:type="pagebreak" id="pg_v" title="v">I’ve always thought of myself as a seeker.… I am beguiled by the mystery of life.</span></p>
<p class="FMEPC"><span class="mdash">—</span>O<span class="ePub-SC">PRAH</span> W<span class="ePub-SC">INFREY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2778dfcb